<template>
  <div class="news_details_wrap news-detail-page">
    <PCNavbar selectIndex="4-2"/>
    <MobileNavBar :currentActive="3"/>
    <div class="news_content">
      <el-breadcrumb class="news_bread" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>

      <article class="news_article">
        <header class="news_article_header">
          <h1 class="news_title">
            喜讯｜我司DCDC充电堆顺利通过3C认证
          </h1>
          <div class="news_meta">
            <span class="news_meta_item">来源：山东智能工业装备公司</span>
            <span class="news_meta_sep">·</span>
            <span class="news_meta_item">投稿时间：2026-09-03</span>
          </div>
        </header>

        <div class="article_body">
          <p class="lead">
            近日，我司生产的分体式DCDC充电堆及直流液冷充电终端，顺利通过中国国家强制性产品认证（3C），并取得由方圆标志认证集团有限公司颁发的认证证书。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.cert"
              alt="中国国家强制性产品认证证书"
            >
            <figcaption class="figure_caption">中国国家强制性产品认证证书</figcaption>
          </figure>

          <h2 class="section_title">一、认证概况</h2>

          <p class="body_paragraph">
            本次获证产品包括电动汽车分体式充电堆（型号：ZN-F960-Y-V1、ZN-F720-Y-V1）及直流液冷充电终端（型号：ZN-DT-800-2-L-S）。认证依据为 CNCA-C25-01:2024《电动汽车供电设备》实施规则，产品符合 GB 39752-2024、GB 44263-2024 等国家标准及技术要求。证书编号为 2026122502131699，发证日期为 2026年9月3日，有效期至 2028年8月24日。
          </p>

          <p class="body_paragraph">
            3C认证是我国对涉及人身健康与安全、环境保护等产品实施的强制性准入制度，也是相关产品合法进入市场销售的重要前提。此次认证的取得，表明我司DCDC充电堆产品在电气安全、电磁兼容、结构防护等方面已达到国家强制性标准要求，为产品的规模化应用与市场化推广提供了权威合规保障。
          </p>

          <h2 class="section_title">二、产品与应用价值</h2>

          <p class="body_paragraph">
            分体式DCDC充电堆采用模块化架构与高功率输出设计，具备部署灵活、扩展便捷等特点，可广泛应用于公共充电站、交通枢纽、产业园区及商业综合体等场景。配套直流液冷充电终端在持续大电流输出、散热效率及运维便利性方面表现突出，能够更好满足新能源车辆快速补能需求，提升场站运营效率与用户充电体验。
          </p>

          <p class="body_paragraph">
            业内人士认为，随着新能源汽车保有量持续增长，高功率充电装备的安全准入与标准化建设日益重要。DCDC充电堆作为大功率直流充电系统的核心设备之一，通过3C认证有助于推动该类产品在国内市场的规范化落地，也为行业高质量发展提供了可参考的实践样本。
          </p>

          <h2 class="section_title">三、下一步工作</h2>

          <p class="body_paragraph">
            此次认证是我司长期坚持技术创新与质量管控的阶段性成果。下一步，公司将持续完善质量管理体系，加快DCDC充电堆及相关产品的产业化应用与市场拓展，持续提升产品可靠性与服务能力，携手客户与合作伙伴共建安全、高效、智能的充电基础设施，为新能源汽车产业高质量发展贡献力量。
          </p>
        </div>
      </article>
    </div>

    <div class="news_detail_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      images: {
        cert: require('@/assets/images/news-list/news6/cert.jpg'),
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/news-detail-responsive.scss';
</style>
